import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { ParkingLandingPage } from '../../../features/parking/ui/ParkingLandingPage';
import { IParkingLandingPageData } from '../../../features/parking/domain/pages/IParkingLandingPageData';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IParkingLandingPageData> =
	createGetStaticPropsWithPage(PassengersPageId.Parking);

export default ParkingLandingPage;
